// Test IDs for the Ficha Tecnica (Treatment technical record) feature:
// zones editor, payment section, review status, retoques and the printable
// detail page.

export const TREATMENTS = {
  // Editor de zonas (compartido entre Tratamiento y Retoque)
  zoneAddButton: 'treatment-zone-add-button',
  zoneRowPrefix: 'treatment-zone-row-',
  zoneNameSelectPrefix: 'treatment-zone-name-select-',
  zoneUnitsInputPrefix: 'treatment-zone-units-input-',
  zoneRemoveButtonPrefix: 'treatment-zone-remove-button-',
  zoneTotalUnits: 'treatment-zone-total-units',
  primaryProductSelect: 'treatment-primary-product-select',
  primaryProductUnitHint: 'treatment-primary-product-unit-hint',

  // Pago dentro del modal de Tratamiento/Retoque
  paymentMethodSelect: 'treatment-payment-method-select',
  paymentAmountInput: 'treatment-payment-amount-input',
  paymentExistingNotice: 'treatment-payment-existing-notice',

  // Item del historial (timeline)
  itemUnitsSummary: 'patient-treatment-item-units-summary-', // + treatmentId
  itemPaymentBadgePrefix: 'patient-treatment-item-payment-badge-',
  itemReviewBadgePrefix: 'patient-treatment-item-review-badge-',
  itemViewDetailButtonPrefix: 'patient-treatment-item-view-detail-button-',
  itemTouchupCountPrefix: 'patient-treatment-item-touchup-count-',

  // Modal de retoque
  touchUpAddButtonPrefix: 'treatment-touchup-add-button-',
  touchUpModal: 'treatment-touchup-modal',
  touchUpIncludedCheckbox: 'treatment-touchup-included-checkbox',
  touchUpSaveButton: 'treatment-touchup-save-button',
  touchUpCancelButton: 'treatment-touchup-cancel-button',

  // Pagina de detalle (ficha tecnica imprimible)
  detailPage: 'treatment-detail-page',
  detailBackButton: 'treatment-detail-back-button',
  detailPrintButton: 'treatment-detail-print-button',
  detailRegisterTouchupButton: 'treatment-detail-register-touchup-button',
  detailZonesTable: 'treatment-detail-zones-table',
  detailPaymentInfo: 'treatment-detail-payment-info',
  detailReviewStatus: 'treatment-detail-review-status',
  detailTouchupItemPrefix: 'treatment-detail-touchup-item-',
};
